import { Box, Skeleton, Typography } from "@mui/material";
import type { Theme } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createStyles = (theme: Theme) => ({
  root: {
    display: "grid",
    gap: "4px",
    alignItems: "center",
    justifyItems: "center",
    padding: theme.analysisLayout.cardPadding,
    backgroundColor: theme.semanticColors.surface.blueBg,
    borderLeft: `2px solid ${theme.semanticColors.border.action}`,
    borderRadius: "0 4px 4px 0",
  },
});

interface IndicativeSubtotalCardProps {
  value?: number | null;
  label?: string;
  isLoading?: boolean;
  roundToThousands?: boolean;
  dataCy?: string;
}

export const IndicativeSubtotalCard = ({
  value,
  label,
  isLoading = false,
  roundToThousands = false,
  dataCy,
}: IndicativeSubtotalCardProps): JSX.Element => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const { t } = useTranslation("IndicativeMarketValuationPanel");

  return (
    <Box sx={styles.root}>
      <Typography variant="body1">{label ?? t("subtotal")}</Typography>
      {isLoading ? (
        <Skeleton animation="wave" variant="rounded" width={220} height={40} />
      ) : (
        <Typography variant="pageTitle" data-cy={dataCy}>
          {value != null
            ? `${(roundToThousands ? Math.round(value / 1000) * 1000 : Math.round(value)).toLocaleString("de-DE")} €`
            : "—"}
        </Typography>
      )}
    </Box>
  );
};
